import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user-service/user.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-users-user-new-role-dashboard',
  templateUrl: './users-user-new-role-dashboard.component.html',
  styleUrls: ['./users-user-new-role-dashboard.component.scss']
})
export class UsersUserNewRoleDashboardComponent implements OnInit {

  user;
  centers;
  roles;
  getUserCentersAndRolesSubscription: Subscription;
  getUserInfoSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private activatedRoute: ActivatedRoute,
              private userService: UserService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getUserInfo();
    this.getUserCentersAndRoles();
  }

  private getUserCentersAndRoles() {
    this.getUserCentersAndRolesSubscription = this.userService.getUserCentersAndRoles().subscribe(
      (res) => {
        this.centers = res['centers'];
        this.roles = res['roles'];
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getUserInfo() {
    const internalId = this.activatedRoute.parent.parent.snapshot.params['userid'];
    this.getUserInfoSubscription = this.userService.getUserInfo(internalId).subscribe(
      (res) => {
        this.user = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    const internalId = this.activatedRoute.parent.parent.snapshot.params['userid'];
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-user', 'users-page.add role', '/account/user/' + internalId, [new BRoute('account-page.account', '/account'), new BRoute('users-page.users', '/account/users'), new BRoute('users-page.user detail', '/account/user/' + internalId), new BRoute('users-page.add role')]));
  }
}
